import * as React from 'react';

import logger from 'src/utils/logger';

import {captureSentryException} from 'src/utils/sentry';


type Props = {
  children: React.ReactNode;
  fallback?: (
    arg1: Error,
    arg2?: (() => void) | null | undefined,
  ) => React.ReactNode;
  onError?: (arg1: Error) => unknown;
  onReset?: () => void;
  id?: unknown;
};

type State = {
  error: Error | null | undefined;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, State, any>'.
  state: State = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): State {
    return {error};
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, State, any>'.
  componentDidCatch(error: Error, info: unknown) {
    if (this.props.onError) {
      this.props.onError(error);
    }

    logger.error('[Error Boundary]', error);
    captureSentryException(error, {
      level: 'error',
      tags: {
        context: 'Boundary',
      },
      extra: {
        info,
      },
    });
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, State, any>'.
  componentDidUpdate(prevProps: Props) {
    if (this.state.error && this.props.id !== prevProps.id) {
      this.setState({error: null});
    }
  }

  resetErrorBoundary: () => void = () => {
    if (this.props.onReset) {
      this.props.onReset();
    }
    this.setState({error: null});
  };

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, State, any>'.
  render(): React.ReactNode {
    if (this.state.error) {
      return this.props.fallback
        ? this.props.fallback(this.state.error, this.resetErrorBoundary)
        : null;
    }

    return this.props.children;
  }
}
